export default "__VITE_ASSET__d4553830__"